module.exports = __webpack_public_path__ + "static/media/patron-2.764a2ace.svg";